import React from 'react'

const Content = ({ children }) => {
  return (
    <div className='flex flex-col w-full p-4 gap-4 sm:h-[calc(100%-64px)] overflow-y-scroll'>
      {children}
    </div>
  )
}
const Actions = ({ children, className }) => {
  return (
    <div className={`w-full h-16 bg-background border-0 sm:border-b border-border ${className || ''}`}>
      <div className='flex flex-row items-center justify-between h-full pr-4'>
        {children}
      </div>
    </div>
  )
}

const BlockLayout = ({ children, className }) => {
  return (
    <div className={`flex sm:flex-col flex-col-reverse justify-end sm:justify-start w-full h-full  overflow-hidden ${className || ''}`}>
      {children}
    </div>
  )
}

BlockLayout.Content = Content
BlockLayout.Actions = Actions

export default BlockLayout
